import React from "react";
import ExcelUploadForm from "../../components/ExcelUploadForm";

function ExcelToPdfPage() {
  return (
    <main style={{ maxWidth: "1180px", margin: "0 auto", padding: "24px 16px" }}>
      <h1 style={{ marginBottom: 16 }}>Upload Excel to PDF</h1>
      <ExcelUploadForm />
    </main>
  );
}

export default ExcelToPdfPage;
